import "./BookList.css";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { useDispatch } from "react-redux";
import { BsBookmarkStar, BsBookmarkStarFill } from "react-icons/bs";
import {
   deleteBook,
   toggleFavorit,
   selectBooks,
} from "../../redux/slices/booksSlice";
import {
   selectTitleFilter,
   selectAuthorFilter,
   selectIsFavoritFilter,
} from "../../redux/slices/filterSlice";

const BookList = () => {
   const books = useSelector(selectBooks);
   const titleFilter = useSelector(selectTitleFilter);
   const authorFilter = useSelector(selectAuthorFilter);
   const isFavoritFilter = useSelector(selectIsFavoritFilter);
   const dispatch = useDispatch();

   const deleteBookHendler = (id) => {
      dispatch(deleteBook(id));
   };

   const toggleFavoritHendler = (id) => {
      dispatch(toggleFavorit(id));
   };

   const filteredBooks = books.filter((book) => {
      const matchesTitle = book.title
         .toLowerCase()
         .includes(titleFilter.toLowerCase());
      const matchesAuthor = book.author
         .toLowerCase()
         .includes(authorFilter.toLowerCase());
      //* my messod
      // const matchesIsFavorit = book.isFavorit === true;
      // if (isFavoritFilter === true) {
      //    return matchesTitle && matchesAuthor && matchesIsFavorit;
      // }
      // return matchesTitle && matchesAuthor;
      // ? teacher messod
      const matchesIsFavorit = isFavoritFilter ? book.isFavorit : true;
      return matchesTitle && matchesAuthor && matchesIsFavorit;
   });

   const hightlightMatch = (text, filter) => {
      if (!filter) return text;
      const regex = new RegExp(`(${filter})`, "gi");
      return text.split(regex).map((substring, i) => {
         if (substring.toLowerCase() === filter.toLowerCase()) {
            return (
               <span key={i} className="highlight">
                  {substring}
               </span>
            );
         }
         return substring;
      });
   };

   return (
      <div className="app-block book-list">
         <h2>Book list</h2>
         {filteredBooks.length === 0 ? (
            <p>No books available</p>
         ) : (
            <ul>
               {filteredBooks.map((book, index) => (
                  <li key={book.id}>
                     <div className="book-info">
                        {++index}. {hightlightMatch(book.title, titleFilter)} by{" "}
                        <strong>
                           {hightlightMatch(book.author, authorFilter)}
                        </strong>{" "}
                        ({book.source})
                     </div>
                     <div className="book-actions">
                        <span onClick={() => toggleFavoritHendler(book.id)}>
                           {book.isFavorit ? (
                              <BsBookmarkStarFill className="star-icon" />
                           ) : (
                              <BsBookmarkStar className="star-icon" />
                           )}
                        </span>
                        <button onClick={() => deleteBookHendler(book.id)}>
                           delete
                        </button>
                     </div>
                  </li>
               ))}
            </ul>
         )}
      </div>
   );
};

export default BookList;
